import { LeadForm } from "@2u-landing-pages/components";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import React from "react";
import styles from "./Section10.module.scss";

export const Section10 = React.forwardRef((props, ref) => {
  return (
    <section id="multi-step-form" ref={ref} className={`${styles.container} cc--component-container rv-lead-form`}>
      <div className={styles.form}>
        <LeadForm
          packageId="2922"
          enableStyles={false}
          footnote={{
            data: {},
            content: [
              {
                data: {},
                content: [
                  {
                    data: {},
                    marks: [],
                    value:
                      "By consenting to receive communications, you agree to the use of your data as described in GetSmarter’s ",
                    nodeType: "text",
                  },
                  {
                    data: {
                      uri: "https://www.getsmarter.com/privacy-policy",
                    },
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: "privacy policy",
                        nodeType: "text",
                      },
                    ],
                    nodeType: INLINES.HYPERLINK,
                  },
                  {
                    data: {},
                    marks: [],
                    value: ". You may opt out of receiving communications at any time.",
                    nodeType: "text",
                  },
                ],
                nodeType: BLOCKS.PARAGRAPH,
              },
            ],
            nodeType: BLOCKS.DOCUMENT,
          }}
        />
      </div>
    </section>
  );
});

Section10.displayName = "Section10";
